import BackOfficeLoginComponent from '@/components/authentication/login/BackOfficeLogin.component.vue'
import LoginViaSmsComponent from '@/components/authentication/login/LoginViaSms.component.vue'
import LoginViaSsoComponent from "@/components/authentication/login/LoginViaSso.component.vue";
import EmailSentComponent from '@/components/authentication/login/success/EmailSent.component.vue'
import ForgotPasswordComponent from '@/components/authentication/password/ForgotPassword.component.vue'
import PasswordExpiredComponent from '@/components/authentication/password/PasswordExpired.component.vue'
import ResetPasswordComponent from '@/components/authentication/password/ResetPassword.component.vue'
import ActivityLoansComponent from "@/components/dashboard/activity-loans/ActivityLoans.component";
import AgentImpersonatorsComponent from '@/components/dashboard/agent-impersonators/AgentsImpersonators.component'
import ArchiveDocumentsOpenerComponent
  from "@/components/dashboard/archive-documents-opener/ArchiveDocumentsOpener.component";
import ConcentrationOfInquiriesComponent
  from "@/components/dashboard/concentration-of-inquiries/ConcentrationOfInquiries.component";
import CreditIndicationComponent from "@/components/dashboard/credit-indication/CreditIndication.component";
import CRMConfigManagementComponent from "@/components/dashboard/crm-config-management/CRMConfigManagement.component";
import CustomerServiceComponent from "@/components/dashboard/customer-service/CustomerService.component";
import DocumentsComponent from '@/components/dashboard/documents/Documents.component'
import EntitlementSimulatorComponent
  from "@/components/dashboard/entitlement-simulator/EntitlementSimulatorComponent.vue";
import FindMembersOrEmployersComponent
  from "@/components/dashboard/find-member-or-employer/FindMembersOrEmployers.component";
import FundYieldsComponent from "@/components/dashboard/funds-yields/FundYields.component";
import SuccessLogoutComponent from '@/components/dashboard/header/logout/SuccessLogout.vue'
import ImpersonatorsComponent from '@/components/dashboard/impersonators/Impersonators.component'
import ImportantLinksComponent from '@/components/dashboard/important-links/ImportantLinks.component'
import MembersProcessesComponent from '@/components/dashboard/jobscreen/membersprocesses/MembersProcesses.component'
import LoanConfigurationComponent from "@/components/dashboard/loan-config/LoanConfiguration.component";
import LoansManagementComponent from "@/components/dashboard/loans-management/LoansManagement.component";
import LobbyComponent from '@/components/dashboard/lobby/Lobby.component'
import MessagesAndLettersComponent from "@/components/dashboard/messages-and-letters/MessagesAndLetters.component";
import MngCompanyMessagesComponent from '@/components/dashboard/mng-company-messages/MngCompanyMessages.component'
import OfficerConfig from "@/components/dashboard/officer-config/OfficerConfig.vue";
import ProcessManagementComponent from "@/components/dashboard/process-management/ProcessManagementComponent.component";
import SearchCustomerServiceComponent
  from '@/components/dashboard/search-customer-service/SearchCustomerService.component'
import SearchEmployersComponent from '@/components/dashboard/search-employers/SearchEmployers.component.vue'
import SearchEmployerRegistrationComponent
  from '@/components/dashboard/search-registrations/SearchEmployerRegistrations.component'
import UsersGiladComponent from "@/components/dashboard/users-gilad/UsersGilad.component";
import UsersMonitoringComponent from '@/components/dashboard/users-monitoring/UsersMonitoring.component'
import UsersPhoneUpdate from '@/components/dashboard/users-phone-update/UsersPhoneUpdate.component'

import UsersComponent from '@/components/dashboard/users/Users.component'
import CompatibilityErrorComponent from '@/components/errors/CompatibilityError.vue'
import ErrorComponent from '@/components/errors/Error.vue'
import MaintenanceErrorComponent from '@/components/errors/MaintenanceError.vue'
import NotFoundErrorComponent from '@/components/errors/NotFoundError.vue'
import SessionTimeoutErrorComponent from '@/components/errors/SessionTimeoutError.vue'
import UnauthorizedErrorComponent from '@/components/errors/UnauthorizedError.vue'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//authNotRequired: no token needed
//hideHeaderAndMenu: header and side menu not visible
//noAuthPageCheck: no authorized page check
//windowRedirectAfter: hard reload before route
//resetStore: reset store/local storage

export default new Router({
  mode: 'hash',
  routes: [{
    path: '/login/:managingCompany',
    name: 'login',
    component: BackOfficeLoginComponent,
    meta: {
      authNotRequired: true,
      windowRedirectAfter: true,
      resetStore: true
    }
  }, {
    path: '/expired',
    name: 'expired',
    component: PasswordExpiredComponent,
    meta: {
      hideHeaderAndMenu: true,
      noAuthPageCheck: true
    }
  }, {
    path: '/pw',
    name: 'reset',
    component: ResetPasswordComponent,
    meta: {authNotRequired: true},
    props: (route: any) => ({
      resetPwToken: route.query.t,
      managingCompany: route.query.mc
    })
  }, {
    path: '/forgot',
    name: 'forgot',
    component: ForgotPasswordComponent,
    meta: {authNotRequired: true}
  }, {
    path: '/viasms',
    name: 'viasms',
    component: LoginViaSmsComponent,
    meta: {authNotRequired: true},
    props: true
  }, {
    path: '/mail-sent',
    name: 'mailsent',
    component: EmailSentComponent,
    meta: {authNotRequired: true}
  }, {
    path: '/success-logout',
    name: 'success-logout',
    component: SuccessLogoutComponent,
    meta: {authNotRequired: true}
  }, {
    path: '/viasso',
    name: 'viasso',
    component: LoginViaSsoComponent,
    meta: {authNotRequired: true},
    props: true
  }, {
    path: '/lobby',
    name: 'lobby',
    component: LobbyComponent,
    meta: {
      noPadding: true
    }
  }, {
    path: '/search-employers',
    name: 'search-employers',
    component: SearchEmployersComponent
  }, {
    path: '/search-employer-registrations',
    name: 'search-employer-registrations',
    component: SearchEmployerRegistrationComponent
  }, {
    path: '/search-customer-service',
    name: 'search-customer-service',
    component: SearchCustomerServiceComponent
  }, {
    path: '/impersonators',
    name: 'impersonators',
    component: ImpersonatorsComponent
  }, {
    path: '/notices-and-updates',
    name: 'notices-and-updates',
    component: MessagesAndLettersComponent

  }, {
    path: '/archive-documents-opener',
    name: 'archive-documents-opener',
    component: ArchiveDocumentsOpenerComponent

  }, {
    path: '/agent-impersonators',
    name: 'agent-impersonators',
    component: AgentImpersonatorsComponent
  }, {
    path: '/loans-management',
    name: 'loans-management',
    component: LoansManagementComponent
  }, {
    path: '/process-management',
    name: 'process-management',
    component: ProcessManagementComponent
  }, {
    path: '/entitlement-simulator',
    name: 'entitlement-simulator',
    component: EntitlementSimulatorComponent
  }, {
    path: '/Credit-indication',
    name: 'Credit-indication',
    component: CreditIndicationComponent
  }, {
    path: '/loan-configuration',
    name: 'loan-configuration',
    component: LoanConfigurationComponent
  }, {
    path: '/customer-service',
    name: 'customer-service',
    component: CustomerServiceComponent
  },{
    path: '/funds-yields',
    name: 'funds-yields',
    component: FundYieldsComponent
  }, {
    path: '/concentration-of-inquiries',
    name: 'concentration-of-inquiries',
    component: ConcentrationOfInquiriesComponent
  }, {
    path: '/find-employer-or-member',
    name: 'find-employer-or-member',
    component: FindMembersOrEmployersComponent
  }, {
    path: '/crm-config-management',
    name: 'crm-config-management',
    component: CRMConfigManagementComponent
  }
    , {
      path: '/officer-config',
      name: 'officer-config',
      component: OfficerConfig
    }
    , {
      path: '/activity-loans',
      name: 'activity-loans',
      component: ActivityLoansComponent
    },
    {
      path: '/users',
      name: 'users',
      component: UsersComponent
    },
    {
      path: '/users-management',
      name: 'users-management',
      component: UsersGiladComponent
    }, {
      path: '/documents',
      name: 'documents',
      component: DocumentsComponent
    }, {
      path: '/mng-company-messages',
      name: 'mng-company-messages',
      component: MngCompanyMessagesComponent
    }, {
      path: '/members-processes',
      name: 'members-processes',
      component: MembersProcessesComponent
    }, {
      path: '/important-links',
      name: 'important-links',
      component: ImportantLinksComponent
    }, {
      path: '/users-monitoring',
      name: 'users-monitoring',
      component: UsersMonitoringComponent
    }, {
      path: '/users-phone-update',
      name: 'users-phone-update',
      component: UsersPhoneUpdate
    }, {
      path: '/error',
      name: 'error',
      component: ErrorComponent,
      meta: {authNotRequired: true},
      props: true
    }, {
      path: '/session-timeout',
      name: 'session-timeout',
      component: SessionTimeoutErrorComponent,
      meta: {authNotRequired: true}
    }, {
      path: '/maintenance',
      name: 'maintenance',
      component: MaintenanceErrorComponent,
      meta: {authNotRequired: true}
    }, {
      path: '/compatibility',
      name: 'compatibility',
      component: CompatibilityErrorComponent,
      meta: {authNotRequired: true}
    }, {
      path: '/unauthorized',
      name: 'unauthorized',
      component: UnauthorizedErrorComponent,
      meta: {
        hideHeaderAndMenu: true,
        noAuthPageCheck: true
      }
    }, {
      path: '/not-found',
      name: 'not-found',
      component: NotFoundErrorComponent,
      meta: {authNotRequired: true}
    }, {
      path: '/*',
      component: NotFoundErrorComponent,
      meta: {authNotRequired: true}
    }]
})
